import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface Props {
  showConfirmationModal: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  title: string;
}

const ConfirmationModal: React.FC<Props> = (
  { showConfirmationModal, setShowConfirmationModal, title }
) => {
  return (
    <Modal
      show={showConfirmationModal}
      onHide={() => setShowConfirmationModal(false)}
      animation={false}
      data-testid='downloadable-confirmation-modal'
    >
      <Modal.Header closeButton className='ps-45 pe-4'>
        <h2 className='modal-title fs-2'>
          Report downloaded successfully!
        </h2>
      </Modal.Header>
      <Modal.Body className='p-0'>
        {/* eslint-disable-next-line max-len*/}
        <div className='fw-bold d-flex flex-column justify-content-center align-items-center px-45 pt-4 pb-45'>
          <i className='fal icon-check-circle fs-2' aria-hidden='true' />
          <p className='text-center mt-25'>
            You have successfully downloaded the report:
          </p>
          <p className='text-orange-devex mt-25'>
            {title}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
